import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class PersonCountService {


_url= 'https://ciot.appointele.com/api';

                       
constructor(private _http: HttpClient) { }


  getAllPersonCountStats(branch, year) {
    console.log(year);
    return this._http.get(`${this._url}/all_personcount_current_stats_get.php?branch=${branch}&year=${year}`).pipe(
      map((res) => {
       
        console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }




  /*************************************************************************** */
  getGraphData(branch, year) {
    console.log(year);
    return this._http.get(`${this._url}/person_count_graph_data_get.php?branch=${branch}&year=${year}`).pipe(
      map((res) => {
       
       
        console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }




  /*************************************************************************** */
  private handleError(error: HttpErrorResponse) {
    // console.log(error);
   
    
     // return an observable with a user friendly message
     return throwError('Error! something went wrong.');
   }
  
   


}
